import React, { useEffect, useState } from "react";
import { Col, Row, Image, Modal } from "react-bootstrap";
import { truncateText } from "../../constant/TruncateText";
import ImgDoc from "../../assets/images/doc.png";
import Edit from "../../assets/images/ic-edit.svg";
import Delete from "../../assets/images/ic-deletebox.svg";
import ModalDelete from "../../assets/images/delete-bin-line.svg";
import icTitle from "../../assets/images/ic-edit-modal.svg";
import "bootstrap/dist/css/bootstrap.min.css";
import ENGModalHeader from "../modal/ENGModalHeader";
import ENGModalBody from "../modal/ENGModalBody";
import EmptyRow from "../emptyRow/EmptyRow";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { GetDeleteMaterial } from "../../features/learning/deleteMaterialSlice";
import { GetUpdateMaterial } from "../../features/learning/updateMaterialSlice";
import FileUpload from "../textField/FileUpload";
import { GetDocumentModule } from "../../features/learning/DocumentSlice";
import { GetLearningModule } from "../../features/learning/learningModuleSlice";
import { GetCounsellorModule } from "../../features/learning/CounsellorSlice";
import icNext from "../../assets/images/ic-arrow-next.svg";
import { useForm } from "react-hook-form";
import { isPermited } from "../../features/localStorage";
import MultiSelectCompany from "../textField/MultiSelectCompany";
import {
  GetAllCompany,
  selectAllCompany,
} from "../../features/company/companyListSlice";
import Dropdown from "../dropdown/Dropdown";
import { useParams } from "react-router-dom";
import {
  GetCategoryList,
  GetCategoryListAsync,
} from "../../features/learning/CategorySlice";
//import MultiSelectCompCompany from "../textField/MultiSelectCompCompany";

const required = "This field is required";
const maxLength = "Your input exceed maximum length";
// Error Component
const errorMessage = (error: any) => {
  return <div className="invalid-feedback">{error}</div>;
};
const RowItemAdmin = ({
  type,
  item,
  lg = 3,
  xs = 12,
  moduleid,
  fetchLearningModuleData,
}: {
  type: number;
  item: any;
  lg?: number;
  xs?: number;
  moduleid: number;
  fetchLearningModuleData: any;
}) => {
  const params = useParams();
  const { categoryId }: any = params;

  // Edit Modal Code
  const [category, setCategory] = useState<any>("");
  const [modalShow, setModalShow] = useState(false);
  const handleClose = () => setModalShow(false);
  const [materialId, setMaterialId] = useState();
  const allCompany = useAppSelector(selectAllCompany);
  const [buId, setBuId] = useState([item.buid]);
  const [sectorId, setSectorId] = useState([item.sectorId]);
  const [companyId, setCompanyId] = useState([item.companyId]);

  // Delete Modal Code
  const [modalShow1, setModalShow1] = useState(false);
  const handleClose1 = () => setModalShow1(false);
  const handleShow1 = () => setModalShow1(true);
  const [title, setTitle] = useState(item?.title);
  const [file, setFile] = useState("");
  const [description, setDescription] = useState(item?.description);
  const userDetails = localStorage.getItem("userDetails");
  const userDetailsList: any = userDetails;
  const userDetailsJson = JSON.parse(userDetailsList);
  const [deleteDetails, setDeleteDetails] = useState<any>();
  const [paste, setPaste] = useState("");
  const isAdmin = localStorage.getItem("isAdmin");
  const isAdminList: any = isAdmin;
  const isAdminJson = JSON.parse(isAdminList);
  const [selectedCompany, setSelectedCompany] = useState([]);
  const dispatch = useAppDispatch();
  var searchParams: any;

  useEffect(() => {
    if(categoryId){
      setCategory(categoryId);
    }
  }, [categoryId]);

  useEffect(() => {
    if (isAdminJson === false) {
      // call non sso comapny with id
      const fetchCompany = async () => {
        await dispatch(
          GetAllCompany(
            (searchParams = { type: 2, id: userDetailsJson.companyId })
          )
        );
      };
      fetchCompany();
    } else {
      // call sso +non sso company
      const fetchAllComany = async () => {
        await dispatch(GetAllCompany((searchParams = { type: "", id: 0 })));
      };
      fetchAllComany();
    }
  }, []);

  const categoryList = useAppSelector(GetCategoryList);
  const [dataList, setDataList] = useState<any>([]);

  useEffect(() => {
    dispatch(GetCategoryListAsync());
  }, []);

  useEffect(() => {
    if (categoryList?.length > 0) {
      let list: any = [];
      // let categoryDropdown: any = [];
      categoryList?.map((val: any) => {
        let obj = {
          id: val?.id,
          name: val?.categoryName,
          title: val?.categoryName,
          description: val?.categoryDescription,
          externalUrl: `/learning/${val?.id}`,
        };
        list = [...list, obj];
      });
      setDataList([...list]);
    }
  }, [categoryList]);

  const handleShow = (item: any) => {
    setModalShow(true);
    setMaterialId(item.id);
    setTitle(item.title);
    setDescription(item.description);
    setFile(item.materialPath);
    setCompanyId(item.companyId);
    setSelectedCompany(item?.companyId);
  };

  const { register, handleSubmit, errors } = useForm();
  const onSubmit = async (event: any) => {
    //event.preventDefault();
    var setBuid = buId.toString();
    var setSectorId = sectorId.toString();
    var setCompnayId = companyId.toString();
    var postdata = {
      title: title,
      moduleId: moduleid,
      description: description,
      mediaType: 'Documents',
      materialPath: file,
      externalUrl: paste,
      moduleType: 'Learning Modules',
      companyId: setCompnayId,
      buid: setBuid,
      sectorId: setSectorId,
      materialCategory: category,
    };

    var data = {
      data: postdata,
      id: materialId,
    };
    await dispatch(GetUpdateMaterial(data));
    var getdata = {
      keyword: "",
      offset: 0,
      companyId: userDetailsJson?.companyId,
    };
    await dispatch(GetDocumentModule(getdata));
    await dispatch(GetLearningModule(getdata));
    await dispatch(GetCounsellorModule(getdata));
    handleClose();
  };

  const onDeleteModalShow = (item: any) => {
    setModalShow1(true);
    setDeleteDetails(item);
  };

  const onDeleteRecord = async () => {
    await dispatch(GetDeleteMaterial(deleteDetails.id));
    var getdata = {
      keyword: "",
      offset: 0,
      companyId: userDetailsJson.companyId,
    };
    await fetchLearningModuleData(item);
    await dispatch(GetDocumentModule(getdata));
    await dispatch(GetLearningModule(getdata));
    await dispatch(GetCounsellorModule(getdata));
    // await window.location.reload();
    setModalShow1(false);
  };

  return (
    <>
      <Col lg={lg} sm={lg} xs={xs}>
        <div className='desk'>
          <div style={styles.codeofconduct}>
            <a
              href={item?.materialPath}
              rel='noopener noreferrer'
              target='_blank'
            >
              <img src={ImgDoc} style={styles.img} alt='icon' />
            </a>
            <p style={styles.title}>{truncateText(item?.title, 40)}</p>
            <p style={styles.content}>{truncateText(item?.description, 50)}</p>
            <Row>
              <Col sm={8}>
                {item.moduleId !== 4 &&
                item.moduleId !== 5 &&
                item.moduleId !== 6 ? (
                  <a
                    href={item?.externalUrl}
                    target='_blank'
                    rel='noopener noreferrer'
                    style={styles.link}
                  >
                    {'GO TO THE LINK'}
                    {'  '}{' '}
                    <span style={{ fontSize: '18px' }}>
                      <Image
                        src={icNext}
                        style={{
                          width: '15px',
                          height: '15px'
                        }}
                      />
                    </span>
                  </a>
                ) : (
                  <a
                    href={item?.materialBase64}
                    target='_blank'
                    rel='noopener noreferrer'
                    style={styles.link}
                  >
                    {'VIEW'}
                    {'  '}{' '}
                    <span style={{ fontSize: '18px' }}>
                      <Image
                        src={icNext}
                        style={{
                          width: '15px',
                          height: '15px'
                        }}
                      />
                    </span>
                  </a>
                )}
              </Col>
              <Col sm={2}>
                {isPermited(1, 3) &&
                  isPermited(2, 3) &&
                  isPermited(3, 3) &&
                  isPermited(4, 3) &&
                  isPermited(5, 3) &&
                  isPermited(6, 3) && (
                    <a onClick={() => handleShow(item)}>
                      {' '}
                      <span style={styles.editstyle}>
                        <Image src={Edit} />
                      </span>
                    </a>
                  )}
                <Modal
                  show={modalShow}
                  onHide={handleClose}
                  backdrop='static'
                  size='lg'
                  keyboard={false}
                >
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <ENGModalHeader icon={icTitle} title=' Edit Module ' />
                    <ENGModalBody
                      contents={
                        <>
                          <form>
                            <Row style={styles.divWhite}>
                              {moduleid !== 2 && moduleid !== 6 ? (
                                <Col sm={12} className='desk'>
                                  <Dropdown
                                    id='Category'
                                    data={dataList}
                                    value={category}
                                    onchange={setCategory}
                                  />
                                  <EmptyRow />
                                </Col>
                              ) : null}
                              <Col lg={6}>
                                <input type='hidden' defaultValue={item.id} />
                                <div className='floating-label-group'>
                                  <input
                                    type='text'
                                    name='title'
                                    defaultValue={item.title}
                                    ref={register({ required: true })}
                                    onChange={(
                                      ev: React.ChangeEvent<HTMLInputElement>
                                    ) => setTitle(ev.target.value)}
                                    className='textstyle'
                                  />
                                  <label className='floating-label'>
                                    Title <span style={styles.star}> * </span>
                                  </label>
                                </div>
                                {errors.title &&
                                  errors.title.type === 'required' &&
                                  errorMessage(required)}
                              </Col>
                              <Col lg={6}>
                                {/* <div className="floating-label-group"> 
                                <input
                                  type="file"
                                  id="File"
                                  defaultValue={item.file}
                                  onChange={(
                                    ev: React.ChangeEvent<HTMLInputElement>
                                  )=> setFile(ev.target.value)}
                                  className="textstyle"
                                />
                                <label className="floating-label">File <span style={styles.star}> * </span></label>
                              </div> */}
                                <FileUpload
                                  setFile={setFile}
                                  title='File'
                                  fileValue={item.materialPath}
                                  fileType='PDF'
                                />
                              </Col>
                            </Row>
                            <Row style={styles.divWhite}>
                              <Col lg={12}>
                                <div className='floating-label-group'>
                                  <input
                                    type='text'
                                    name='description'
                                    ref={register({ required: true })}
                                    defaultValue={item.description}
                                    onChange={(
                                      ev: React.ChangeEvent<HTMLInputElement>
                                    ) => setDescription(ev.target.value)}
                                    className='textstyle'
                                  />
                                  <label className='floating-label'>
                                    Description{' '}
                                    <span style={styles.star}> * </span>
                                  </label>
                                </div>
                                {errors.description &&
                                  errors.description.type === 'required' &&
                                  errorMessage(required)}
                              </Col>
                              {moduleid !== 4 &&
                              moduleid !== 5 &&
                              moduleid !== 6 ? (
                                <Col lg={6} className='mt-5'>
                                  <div className='floating-label-group'>
                                    <input
                                      type='text'
                                      name='link'
                                      ref={register({ required: true })}
                                      defaultValue={item.externalUrl}
                                      onChange={(
                                        ev: React.ChangeEvent<HTMLInputElement>
                                      ) => setPaste(ev.target.value)}
                                      className='textstyle'
                                    />
                                    <label className='floating-label'>
                                      Paste URL{' '}
                                      <span style={styles.star}> * </span>
                                    </label>
                                  </div>
                                  {errors.link &&
                                    errors.link.type === 'required' &&
                                    errorMessage(required)}
                                </Col>
                              ) : null}
                              <Col lg={6} className='mt-4'>
                                <label htmlFor='Unit'>Accessible To</label>

                                <MultiSelectCompany
                                  optionList={allCompany}
                                  setId={setCompanyId}
                                  selectedValue={selectedCompany}
                                  valueKey='id'
                                  labelKey='company'
                                  isAdd={false}
                                />
                              </Col>
                            </Row>
                          </form>
                        </>
                      }
                    />
                    <EmptyRow />
                    <EmptyRow />
                    <Row style={styles.divGrey}>
                      <Col sm={9}></Col>
                      <Col sm={3}>
                        <button
                          type='button'
                          onClick={handleClose}
                          style={styles.button1}
                        >
                          {' '}
                          CANCEL{' '}
                        </button>
                        <button type='submit' style={styles.button}>
                          {' '}
                          SAVE{' '}
                        </button>
                      </Col>
                    </Row>
                  </form>
                </Modal>
              </Col>
              <Col sm={2}>
                {isPermited(1, 4) &&
                  isPermited(2, 4) &&
                  isPermited(3, 4) &&
                  isPermited(4, 4) &&
                  isPermited(5, 4) &&
                  isPermited(6, 4) && (
                    <a onClick={() => onDeleteModalShow(item)}>
                      {' '}
                      <span style={styles.editstyle}>
                        <Image src={Delete} />
                      </span>
                    </a>
                  )}
                <Modal
                  show={modalShow1}
                  onHide={handleClose1}
                  backdrop='static'
                  size='lg'
                  keyboard={false}
                >
                  <ENGModalHeader icon={ModalDelete} title=' Delete Module ' />
                  <ENGModalBody
                    contents={
                      <>
                        <Row style={styles.divWhite}>
                          <Col lg={12}>
                            <p style={styles.delcontent}>
                              Are you sure you want delete this module?
                            </p>
                          </Col>
                        </Row>
                      </>
                    }
                  />
                  <EmptyRow />
                  <EmptyRow />
                  <EmptyRow />
                  <EmptyRow />
                  <Row style={styles.divGrey}>
                    <Col sm={9}></Col>
                    <Col sm={3}>
                      <button
                        type='button'
                        onClick={handleClose1}
                        style={styles.button1}
                      >
                        {' '}
                        CANCEL{' '}
                      </button>
                      <button
                        type='button'
                        onClick={onDeleteRecord}
                        style={styles.button}
                      >
                        {' '}
                        DELETE{' '}
                      </button>
                    </Col>
                  </Row>
                </Modal>
              </Col>
            </Row>
          </div>
        </div>
      </Col>
    </>
  );
};

const styles: any = {
  selectpoperty: {
    backgroundColor: "white",
    paddingBottom: "0px",
    border: "solid 1px #e4e4e4",
    width: "100%",
    fontFamily: "Georama-Regular",
    fontSize: "16px",
    color: "#6d6e71",
    borderRadius: "0px",
  },
  star: { color: "#e31837" },
  divWhite: {
    backgroundColor: "#ffffff",
    paddingTop: "20px",
    margin: "0px",
    paddingLeft: "10px",
    paddingRight: "10px",
  },

  button: {
    padding: "13px 20px",
    fontFamily: "Georama-Regular",
    fontSize: "12px",
    fontWeight: 400,
    fontStretch: "normal",
    fontStyle: "normal",
    borderRadius: "0",
    backgroundColor: "#e31837",
    letterSpacing: "normal",
    border: "0px",
    color: "#fff",
    float: "right",
  },
  button1: {
    padding: "13px 15px",
    fontFamily: "Georama-Regular",
    fontSize: "12px",
    fontWeight: "500",
    fontStretch: "normal",
    fontStyle: "normal",
    borderRadius: "0",
    backgroundColor: "#ffffff",
    border: "1px solid #e31837",
    letterSpacing: "normal",
    color: "#e31837",
  },
  divGrey: {
    backgroundColor: "rgb(250, 249, 249)",
    paddingTop: "20px",
    margin: "0px",
    paddingLeft: "10px",
    paddingRight: "10px",
    paddingBottom: "20px",
    borderTop: "1px solid #eee;",
  },

  delcontent: {
    fontSize: "16px",
    color: "#242424",
  },

  editstyle: {
    color: "#e31837",
    fontFamily: "Georama-Regular",
    fontWeight: 600,
    fontSize: "12px",
    float: "right",
    marginTop: "10px",
  },
  checkb: {
    boxSizing: "border-box",
    boxShadow: "inset 0px 0px 0px 2px #e31837",
    width: "18px",
    height: "18px",
    // marginLeft: "8px",
    marginBottom: "15px",
  },

  img: {
    backgroundColor: "rgba(236, 236, 236, 0.3)",
    padding: "14px",
    borderRadius: "50%",
  },
  title: {
    fontFamily: "Georama-Regular",
    fontSize: "18px",
    fontWeight: 600,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.44,
    letterSpacing: "normal",
    paddingLeft: "5px",
    paddingTop: "10px",
    padding: "20px 5px 8px",
  },

  link: {
    color: "#e31837",
    float: "left",
    fontFamily: "Georama-Regular",
    fontSize: "12px",
    fontWeight: "bold",
    textDecoration: "none",
  },

  content: {
    fontFamily: "Georama-Regular",
    fontSize: "14px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.57,
    paddingLeft: "5px",
    marginBottom: "0.5rem",
  },

  codeofconduct: {
    border: "1px solid #eee",
    padding: "15px",
    marginBottom: "20px",
    backgroundColor: "#ffffff",
  },

  codeofconductmob: {
    border: "1px solid #eee",
    padding: "25px 20px",
    MarginBottom: "10px",
  },
};

export default RowItemAdmin;
